import { connectedStore } from '../../store';
import setClipboardDataAction from '../actions/set-clipboard-data';
import { UPDATE_STATIC_ONLY } from '../../hdrm/constants/update-strategies';

const setClipboardData = (element, options = { strategy: UPDATE_STATIC_ONLY }) => {
  const store = connectedStore.get();
  store.dispatch(setClipboardDataAction({ element: document.importNode(element, true), options }));
};

export default setClipboardData;
